import { ContractOverviewPathsEnum } from 'modules/contractsOverviewPage/routes';

export enum ContractsOverviewKeys {
  Details = 'contracts-details',
  RepaymentPlan = 'contracts-repayment-plan',
  FacilityInformation = 'contracts-facility-information',
}

export const getContractsOverviewPageUrl = (
  number: string,
  tab: ContractsOverviewKeys,
) => `${ContractOverviewPathsEnum.contractsOverview}/${number}/${tab}`;
